<template>
  <div v-if="showWarning" class="py-2 md:py-5">
    <AlertToast>
      <div class="flex flex-col md:flex-row py-3 px-5 md:px-20">
        <div class="flex flex-row justify-end md:hidden">
          <XIcon class="text-brand-dark-gray w-5 h-5" @click="closeWarning" />
        </div>
        <div class="flex justify-center items-center w-full md:w-1/4">
          <img
            class="w-1/3 md:w-full lg:w-2/3"
            src="@/assets/images/experian-logo.png"
          />
        </div>
        <div class="flex flex-col items-center w-full md:w-2/3">
          <div class="flex flex-col w-full">
            <h3 class="text-center md:text-left py-1">
              Want to order credit reports?
            </h3>
            <p class="text-sm text-center md:text-left py-1">
              To request credit reports, you must first verify your identity
              with Experian.
            </p>
          </div>
          <div class="flex flex-row justify-left w-full py-1">
            <div class="flex w-1/2 md:w-1/3 mr-3">
              <SecondaryButton :classes="'bg-transparent'" @click="closeWarning"
                >Not Now</SecondaryButton
              >
            </div>
            <router-link
              tag="div"
              :to="{ name: 'dashboard_verify_disclaimer' }"
              class="flex w-1/2 md:w-1/3"
            >
              <PrimaryButton>Get Started</PrimaryButton>
            </router-link>
          </div>
        </div>
        <div
          class="hidden md:flex border border-brand-mid-gray ml-20 mr-10"
        ></div>
        <div
          class="
            flex
            justify-center
            md:justify-start
            items-center
            w-full
            md:w-1/3
          "
        >
          <p class="text-brand-dark-gray py-1">Est. 1 - 2 mins.</p>
        </div>
      </div>
    </AlertToast>
  </div>
</template>
<script>
import _ from "lodash"
import { mapGetters } from "vuex"

import { XIcon } from "@heroicons/vue/outline"

export default {
  components: {
    XIcon
  },
  computed: {
    ...mapGetters(["getCurrentUser"])
  },
  watch: {
    getCurrentUser: {
      handler(val) {
        if (val) {
          const experianRSP = _.find(val.report_source_profiles, {
            source_identifier: "experian_credit"
          })
          if (experianRSP && !experianRSP.active) {
            this.showWarning = true
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      showWarning: false
    }
  },
  methods: {
    closeWarning() {
      this.showWarning = false
    }
  }
}
</script>
